import i18n from '~/services/i18n';

export default {
  Cards: {
    VISA: 'visa',
    MASTERCARD: 'mastercard',
    AMEX: 'amex',
    UNIONPAY: 'unionpay',
    CHASE: 'chase',
    JCB: 'jcb',
    DISCOVER: 'discover',
  },

  CardDetails: {
    AMEX: {
      title: i18n('American Express'),
      logo: 'https://cf.quizizz.com/img/cards/amex.png',
    },
    VISA: {
      title: i18n('Visa'),
      logo: 'https://cf.quizizz.com/img/cards/visa.webp',
    },
    UNIONPAY: {
      title: i18n('UnionPay'),
      logo: 'https://cf.quizizz.com/img/cards/unionpay.png',
    },
    CHASE: {
      title: i18n('Chase'),
      logo: 'https://cf.quizizz.com/img/cards/chase.png',
    },
    DISCOVER: {
      title: i18n('Discover'),
      logo: 'https://cf.quizizz.com/img/cards/discover.png',
    },
    JCB: {
      title: i18n('JCB'),
      logo: 'https://cf.quizizz.com/img/cards/jcb.png',
    },
    MASTERCARD: {
      title: i18n('Mastercard'),
      logo: 'https://cf.quizizz.com/img/cards/mastercard.png',
    },
    DEFAULT: {
      title: i18n('Card'),
      logo: 'https://cf.quizizz.com/img/cards/default.png',
    },
  },

  Status: {
    ACTIVE: 'active',
    TRIALING: 'trialing',
    PAST_DUE: 'past_due',
    CANCELLING: 'cancelling',
    FUTURE: 'future',
  },

  StatusName: {
    ACTIVE: i18n('Active'),
    TRIALING: i18n('Trialing'),
    PAST_DUE: i18n('Past due'),
    CANCELLING: i18n('Cancelling'),
    FUTURE: i18n('Future'),
  },

  Interval: {
    YEAR: 'year',
    MONTH: 'month',
  },

  IntervalName: {
    YEAR: i18n('Yearly'),
    MONTH: i18n('Monthly'),
  },

  ProductName: {
    INTRO: 'Intro',
    BASIC: 'Basic',
    PREMIER: 'Premier',
    STANDARD: 'Standard',
    STARTER: 'Starter',
    ENTERPRISE: 'Enterprise',
    ESSENTIAL: 'Essential',
    EVENT: 'Event',
  },

  UPDATE_SUBSCRIPTION_TYPE: {
    UPGRADE: 'upgrade',
    BILLING: 'billing',
    INVITE_MEMBER: 'invite_member',

    // Custom
    CUSTOM_BRANDING: 'custom_branding',
    PARTICIPANT_LIMIT: 'participant_limit',
    COMPLIANCE_MODE: 'compliance_mode',
  },
  TYPE: {
    SUPER: 'SUPER',
    SCHOOL_AND_DISTRICT: 'SCHOOL_AND_DISTRICT',
    BASIC: 'BASIC',
  },
};
